<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
    <div class="col-12">
      <div class="bg-white q-mx-md-md">
        <div style="text-align: center; padding-top: 40px; padding-bottom: 40px">
          <img src="/assets/images/group2.svg" />
        </div>
        <div class="q-px-lg q-py-lg">
          <MainHeadline
            align="center"
            header="ID Check Complete"
            :body="
              (primaryApplicant ? capitalizeFirstLetter(primaryApplicant.firstName) + ' ' + primaryApplicant.lastName : '') +
              ' will contact you to sign the applicable lease documents.'
            "
          />
        </div>
        <div class="q-px-lg q-py-lg" style="text-align: center">
          <QBtn color="primary" outline no-caps @click="onClickHandler()">Log Out</QBtn>
        </div>
        <MoreInfoBlock />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapState, mapGetters } from 'vuex';
import MainHeadline from '../../components/Atoms/MainHeadline';
import MoreInfoBlock from '../../components/Atoms/MoreInfoBlock';

export default {
  name: 'Review',
  components: { QBtn, MainHeadline, MoreInfoBlock },
  props: [],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    }
  },
  created() {},
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      if (string && string.length) return string.charAt(0).toUpperCase() + string.slice(1);
      else return '';
    },
    onClickHandler: function () {
      this.loading = true;
      this.$router.push({ name: 'logout' });
      this.loading = false;
    }
  }
};
</script>
